import classNames from 'clsx'
import { bool, func, number, oneOfType, shape, string } from 'prop-types'
import { Helmet } from 'react-helmet'

import { BREAKPOINT_SMALL_TINY } from 'views/consts'
import withDataQA from 'views/enhancers/withDataQA'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

import { getSourceProps, getSrcSets, mapPropsToImgProps } from './helpers'
import Source from './Source'

const Image = props => {
  const imgProps = mapPropsToImgProps(props)
  const { srcMobile, alt, preconnect } = props
  const { cdnUrl } = usePublicConfig()

  const { srcSet, src } = getSourceProps(imgProps, cdnUrl)
  const { webpSrcSet, mobileSrcSet, mobileWebpSrcSet } = getSrcSets({
    srcSet,
    src,
    srcMobile,
    cdnUrl,
  })

  const sources = [
    mobileWebpSrcSet && (
      <Source
        key="mobile webP"
        media={BREAKPOINT_SMALL_TINY}
        type="image/webp"
        srcSet={mobileWebpSrcSet}
      />
    ),
    mobileSrcSet && (
      <Source
        key="mobile"
        media={BREAKPOINT_SMALL_TINY}
        srcSet={mobileSrcSet}
      />
    ),
    webpSrcSet && <Source key="webP" type="image/webp" srcSet={webpSrcSet} />,
  ].filter(Boolean)

  const img = <img alt={alt} {...imgProps} />

  if (sources.length === 0) {
    return img
  }

  const preconnectHref =
    preconnect && imgProps.src ? new URL(imgProps.src).origin : false

  return (
    <picture className={classNames('a-ResponsiveImage')}>
      {preconnectHref && (
        <Helmet>
          <link rel="preconnect" href={preconnectHref} />
        </Helmet>
      )}
      {sources}
      {img}
    </picture>
  )
}

Image.propTypes = {
  // Could be refactored to accept always string
  src: oneOfType([string, shape({ toString: func.isRequired })]).isRequired,
  srcMobile: oneOfType([string, shape({ toString: func.isRequired })]),
  alt: string.isRequired,
  title: string,
  imageAttrs: shape({}),
  className: string,
  clientsideHook: string,
  width: number,
  height: number,
  lazyLoad: bool,
  preconnect: bool,
  srcWidth: number,
  srcHeight: number,
}

Image.defaultProps = {
  srcMobile: null,
  width: null,
  height: null,
  className: '',
  title: '',
  clientsideHook: '',
  lazyLoad: false,
  preconnect: false,
  srcWidth: null,
  srcHeight: null,
  imageAttrs: null,
}

export default withDataQA(Image)
